const state = {
  showPopup: false,
  shopList: []
}

const mutations = {
  SET_SHOW_POPUP(state, showPopup) {
    state.showPopup = showPopup
  },
  SET_SHOP_LIST(state, shopList) {
    state.shopList = shopList
  }
}

const actions = {
  showPopup({ commit }, shopList) {
    commit('SET_SHOP_LIST', shopList)
    commit('SET_SHOW_POPUP', true)
  },
  hidePopup({ commit }) {
    commit('SET_SHOW_POPUP', false)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
